module.exports = __webpack_public_path__ + "static/media/Francisco St, San Francisco, CA2.74cb4e36.jpg";